<template lang="html">
  <section>
    <v-navigation-drawer
        v-if="['logIn', 'addProduct', 'listProductPage', 'listProductIntroPage'].indexOf($route.name) > -1"
        :clipped="$vuetify.breakpoint.lgAndUp"
        v-model="drawer"
        fixed
        app
      >
      <v-layout column wrap>
        <v-flex xs12>
          <v-btn flat large :to="{ name: 'homePage'}" v-if="['logIn'].indexOf($route.name) > -1">หน้าบ้าน</v-btn>
          <v-btn flat large @click="dialog = true" v-else>หน้าบ้าน</v-btn>
        </v-flex>
        <v-flex xs12>
          <v-btn flat large :to="{ name: 'listProductIntroPage'}" v-if="['addProduct', 'listProductPage', 'listProductIntroPage'].indexOf($route.name) > -1">ภาพพื้นหลัง</v-btn>
        </v-flex>
        <v-flex xs12>
          <v-btn flat large :to="{ name: 'listProductPage'}" v-if="['addProduct', 'listProductPage', 'listProductIntroPage'].indexOf($route.name) > -1">สินค้า</v-btn>
        </v-flex>
        <v-flex xs12>
          <v-btn flat large @click="dialogLogOut = true" v-if="['addProduct', 'listProductPage', 'listProductIntroPage'].indexOf($route.name) > -1">ออกจากระบบ</v-btn>
        </v-flex>
      </v-layout>

      <v-dialog
        v-model="dialog"
        max-width="350"
      >
        <v-card>
          <v-card-title class="headline">คุณต้องการที่จะไปหน้าบ้าน?</v-card-title>
          <v-card-text>
            <v-alert
              :value="true"
              color="error"
              icon="new_releases"
            >
              หากคุณยืนยันระบบจะทำการออกจากระบบอัตโนมัติให้
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="homePageConfirm"
            >
              ยืนยัน
            </v-btn>
            <v-btn
              color="red darken-1"
              flat="flat"
              @click="dialog = false"
            >
              ยกเลิก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogLogOut"
        max-width="350"
      >
        <v-card>
          <v-card-title class="headline">คุณต้องการที่จะออกจากระบบ?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="logOut"
            >
              ยืนยัน
            </v-btn>
            <v-btn
              color="red darken-1"
              flat="flat"
              @click="dialogLogOut = false"
            >
              ยกเลิก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-navigation-drawer>

    <v-navigation-drawer
        v-else
        :clipped="$vuetify.breakpoint.lgAndUp"
        v-model="drawer"
        fixed
        app
      >
        <v-list dense>
          <template v-for="item in items">
            <v-layout
              v-if="item.heading"
              :key="item.heading"
              row
              align-center
            >
            </v-layout>
            <!-- if the item has childern -->
            <v-list-group
              v-else-if="item.children"
              v-model="item.model"
              :key="item.text"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon=""
            >
              <v-list-tile slot="activator" :to="{ name: item.name}">
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.text }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                v-for="(child, i) in item.children"
                :key="i"
                :to="{ name: child.name}"
              >
                <v-list-tile-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ child.text }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>
            <!-- the item do not have childern -->
            <v-list-tile v-else-if="item.name" :key="item.text" :to="{ name: item.name}">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-else :key="item.text">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        color="blue darken-3"
        dark
        app
      >
        <v-toolbar-title style="width: 300px" class="">
          <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
          <span>Naics Furnishing Co., Ltd.</span>
        </v-toolbar-title>
        <v-btn icon large href="/">
        <v-avatar size="32px" tile>
          <img
            :src="require('@/assets/logo.png')"
            :lazy-src="require('@/assets/logo.png')"
            alt="Vuetify"
          >
        </v-avatar>
      </v-btn>
      </v-toolbar>
  </section>

</template>

<script>
import firebase from 'firebase'
export default {
  data: () => ({
    dialog: false,
    drawer: null,
    dialogLogOut: false,
    items: [
      { icon: 'home', text: 'หน้าแรก', name: 'homePage' },
      {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        text: 'สินค้า',
        name: 'product',
        model: true,
        children: [
          { icon: 'star', text: 'สินค้าแนะนำ', name: 'popularProduct' },
          { icon: 'shopping_cart', text: 'เปลเด็ก & เตียงเด็ก', name: 'cradlesProduct' },
          { icon: 'shopping_cart', text: 'ชั้นวาง', name: 'shelvesProduct' },
          { icon: 'shopping_cart', text: 'โต๊ะ & เก้าอี้', name: 'tableSandSeatsProduct' },
          { icon: 'shopping_cart', text: 'ราว', name: 'racksProduct' },
          { icon: 'shopping_cart', text: 'ชั้นรองเท้า', name: 'beddingsProduct' },
          { icon: 'shopping_cart', text: 'ชั้นงานไม้', name: 'woodProduct' },
          { icon: 'shopping_cart', text: 'อื่นๆ', name: 'otherProduct' }
        ]
      },
      { icon: 'person', text: 'เกี่ยวกับเรา', name: 'aboutUs' },
      { icon: 'phone', text: 'ติดต่อเรา', name: 'contactUs' },
      { icon: 'phone', text: 'โทรศัพท์: 035-795-113, 081-763-2077', name: '' },
      { icon: 'email', text: 'อีเมล: kawin@naicsfurnishing.com', name: '' }
    ]
  }),
  methods: {
    logOut: function () {
      const self = this
      firebase.auth().signOut().then(function () {
        self.$router.push('/log-in')
        self.dialogLogOut = false
      })
    },
    homePageConfirm () {
      this.$router.push('/home')
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/extra/headerMobile.vue